<!-- Invite a new Admin -->
<section>
    <div class="container content-box text-center">
        <h1>Invite new admins</h1>

        <!-- Form -->
        <form name="form" class="" (submit)="f.form.valid && onSubmit() " #f="ngForm" novalidate>

            <!-- Email -->
            <div class="row col-sm-12">
                <label for="email" class="col-sm-3 text-end mt-2">Email </label>
                <input class="col-sm-7 form-control " id="email" name="email" [(ngModel)]="model.email" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required>

                <!-- Invalid Email -->
                <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                    <div class="mb-1 text-center" *ngIf="email.errors!.required">Email is required</div>
                </div>
            </div>

            <!-- Type -->
            <div class="row col-sm-12 mt-2">
                <label for="type" class="col-sm-3 text-end mt-2">Type </label>
                <select class="col-sm-7 form-control " id="type" name="type" [(ngModel)]="model.type" #type="ngModel" [ngClass]="{ 'is-invalid': f.submitted && type.invalid }" required>
                  <option value="" selected="selected" disabled="disabled">-- select one --</option>
                  <option value="Agency Admin">Agency Admin </option>
                  <option value="Super Admin">Super Admin</option>
              </select>

                <!-- Invalid Type -->
                <div *ngIf="f.submitted && type.invalid" class="invalid-feedback">
                    <div class="mb-1 text-center" *ngIf="type.errors!.required">Type is required</div>
                </div>
            </div>

            <!-- Super Admins Don't Need an Agency Name -->
            <div *ngIf="model.type  == 'Agency Admin'">

                <!-- Agency -->
                <div class="row col-sm-12 mt-2">
                    <label for="agency" class="col-sm-3 text-end mt-2">Agency </label>
                    <select class="col-sm-7 form-control" id="agency" name="agency" [(ngModel)]="model.agency" #agency="ngModel" [ngClass]="{ 'is-invalid': f.submitted && agency.invalid}" required>
                      <option value="" selected="selected" disabled="disabled">-- select one --</option>
                      <option *ngFor="let item of agencies.agencies" [value]="item.agencyName">
                        {{item.agencyName}}
                      </option>         
                  </select>

                    <!-- Invalid Agency -->
                    <div *ngIf="f.submitted && agency.invalid" class="invalid-feedback">
                        <div class="mb-1 text-center" *ngIf="agency.errors!.required">Agency is required</div>
                    </div>
                </div>
            </div>

            <!-- Submit -->
            <button type="submit" class="btn waves-dark mt-4">Send Invite</button>
        </form>
    </div>
</section>